var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2969 5.71908C17.2969 4.0934 15.9661 2.77594 14.3241 2.77594H5.67593C4.03386 2.77594 2.70312 4.0934 2.70312 5.71908V14.281C2.70312 15.9066 4.03386 17.2241 5.67593 17.2241H14.3241C15.9661 17.2241 17.2969 15.9066 17.2969 14.281V5.71908ZM12.162 7.85955V12.1405C12.162 12.5836 12.5253 12.9432 12.9728 12.9432C13.4203 12.9432 13.7836 12.5836 13.7836 12.1405V7.85955C13.7836 7.41647 13.4203 7.05688 12.9728 7.05688C12.5253 7.05688 12.162 7.41647 12.162 7.85955ZM11.081 12.1405V8.92979C11.081 7.89594 10.2346 7.05688 9.18924 7.05688H8.10822C7.06287 7.05688 6.21644 7.89594 6.21644 8.92979V12.1405C6.21644 12.5836 6.57966 12.9432 7.0272 12.9432C7.47474 12.9432 7.83797 12.5836 7.83797 12.1405V11.3378H9.45949V12.1405C9.45949 12.5836 9.82272 12.9432 10.2703 12.9432C10.7178 12.9432 11.081 12.5836 11.081 12.1405ZM7.83797 9.73246H9.45949V8.92979C9.45949 8.78209 9.33842 8.66223 9.18924 8.66223H8.10822C7.95904 8.66223 7.83797 8.78209 7.83797 8.92979V9.73246Z",
    fill: "#9C85F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8655 10.8027H19.1895C19.6371 10.8027 20.0003 10.4431 20.0003 10C20.0003 9.55693 19.6371 9.19733 19.1895 9.19733H14.8655C14.4179 9.19733 14.0547 9.55693 14.0547 10C14.0547 10.4431 14.4179 10.8027 14.8655 10.8027Z",
    fill: "#9C85F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.809 5.08361V0.802676C10.809 0.359599 10.4458 0 9.99826 0C9.55072 0 9.1875 0.359599 9.1875 0.802676V5.08361C9.1875 5.52669 9.55072 5.88629 9.99826 5.88629C10.4458 5.88629 10.809 5.52669 10.809 5.08361Z",
    fill: "#9C85F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1875 14.9164V19.1973C9.1875 19.6404 9.55072 20 9.99826 20C10.4458 20 10.809 19.6404 10.809 19.1973V14.9164C10.809 14.4733 10.4458 14.1137 9.99826 14.1137C9.55072 14.1137 9.1875 14.4733 9.1875 14.9164Z",
    fill: "#9C85F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15047 9.19733H0.826389C0.378847 9.19733 0.015625 9.55693 0.015625 10C0.015625 10.4431 0.378847 10.8027 0.826389 10.8027H5.15047C5.59801 10.8027 5.96123 10.4431 5.96123 10C5.96123 9.55693 5.59801 9.19733 5.15047 9.19733Z",
    fill: "#9C85F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4865 7.59198H19.1891C19.6366 7.59198 19.9999 7.23239 19.9999 6.78931C19.9999 6.34623 19.6366 5.98663 19.1891 5.98663H16.4865C16.039 5.98663 15.6758 6.34623 15.6758 6.78931C15.6758 7.23239 16.039 7.59198 16.4865 7.59198Z",
    fill: "#9C85F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56684 3.5786V0.903017C7.56684 0.45994 7.20362 0.100342 6.75608 0.100342C6.30853 0.100342 5.94531 0.45994 5.94531 0.903017V3.5786C5.94531 4.02168 6.30853 4.38128 6.75608 4.38128C7.20362 4.38128 7.56684 4.02168 7.56684 3.5786Z",
    fill: "#9C85F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94531 16.4214V19.097C5.94531 19.5401 6.30853 19.8996 6.75608 19.8996C7.20362 19.8996 7.56684 19.5401 7.56684 19.097V16.4214C7.56684 15.9783 7.20362 15.6187 6.75608 15.6187C6.30853 15.6187 5.94531 15.9783 5.94531 16.4214Z",
    fill: "#9C85F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52894 5.98663H0.826389C0.378847 5.98663 0.015625 6.34623 0.015625 6.78931C0.015625 7.23239 0.378847 7.59198 0.826389 7.59198H3.52894C3.97648 7.59198 4.3397 7.23239 4.3397 6.78931C4.3397 6.34623 3.97648 5.98663 3.52894 5.98663Z",
    fill: "#9C85F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4865 14.0134H19.1891C19.6366 14.0134 19.9999 13.6538 19.9999 13.2107C19.9999 12.7676 19.6366 12.408 19.1891 12.408H16.4865C16.039 12.408 15.6758 12.7676 15.6758 13.2107C15.6758 13.6538 16.039 14.0134 16.4865 14.0134Z",
    fill: "#9C85F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0551 3.5786V0.903017C14.0551 0.45994 13.6919 0.100342 13.2444 0.100342C12.7968 0.100342 12.4336 0.45994 12.4336 0.903017V3.5786C12.4336 4.02168 12.7968 4.38128 13.2444 4.38128C13.6919 4.38128 14.0551 4.02168 14.0551 3.5786Z",
    fill: "#9C85F6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4336 16.4214V19.097C12.4336 19.5401 12.7968 19.8996 13.2444 19.8996C13.6919 19.8996 14.0551 19.5401 14.0551 19.097V16.4214C14.0551 15.9783 13.6919 15.6187 13.2444 15.6187C12.7968 15.6187 12.4336 15.9783 12.4336 16.4214Z",
    fill: "#9C85F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51331 12.408H0.810764C0.363222 12.408 0 12.7676 0 13.2107C0 13.6538 0.363222 14.0134 0.810764 14.0134H3.51331C3.96085 14.0134 4.32408 13.6538 4.32408 13.2107C4.32408 12.7676 3.96085 12.408 3.51331 12.408Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlm);
export default __webpack_public_path__ + "static/media/llm.c6917d4082b04210af6802e298c7bde4.svg";
export { ForwardRef as ReactComponent };